const EXPORT_TYPES = {
  BILLING: 'billing',
  DHS: 'dhs',
  UNFILTERED: 'unfiltered',
};

export default EXPORT_TYPES;
